import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from '../../../interceptor/axios-config';
// import axios from 'axios';
import config from '../../../config';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLogo  } from '../../../store/actions/logoActions';

const Uploader = () => {

    const POST_IMAGE = `${config.apiBaseUrl}/logo/uploadLogo.php`;
    const UPLOAD_PDF = `${config.apiBaseUrl}/pdfResult/uploadToFolder.php`;
    const MARKS_ARRAY = `${config.apiBaseUrl}/marks/addMarks.php`;

    const [jsonData, setJsonData] = useState(null);
    const [uploaded, setUploaded] = useState(false);

    const dispatch = useDispatch();
    const { logoUrl } = useSelector((state) => state.logo);

    //This is for Pdf Result
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadSuccess, setUploadSuccess] = useState(false);

    const handlePdfFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

  // Fetch the logo on component mount
  useEffect(() => {
    dispatch(fetchLogo());
  }, [dispatch]);

    // for logo 
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
            const parsedJson = JSON.parse(e.target.result);
            setJsonData(parsedJson);
            } catch (error) {
            console.error('Invalid JSON file', error);
            }
        };
        reader.readAsText(file);
        }
    };

    // console.log(jsonData);

    function isJSONEmpty(obj) {
        return Object.keys(obj).length === 0;
      }

    const uploadData = async () => {
        try {
            if (!jsonData) {
                console.log('No file uploaded. Skipping POST request.');
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'No file uploaded. Skipping POST request.',
                    footer: '<a href="">Why do I have this issue?</a>'
                  })
              } else if (isJSONEmpty(jsonData)) {
                console.log('JSON data is empty. Skipping POST request.');
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'JSON data is empty. Skipping POST request.',
                    footer: '<a href="">Why do I have this issue?</a>'
                  })
              }
            else
            {
                for(var i = 0; i < jsonData.length; i++){
                    // Replace 'your-api-endpoint' with the actual API endpoint where you want to post the JSON data.
                const response = await axios.post(MARKS_ARRAY, jsonData[i]);
                // const response = await axios.post('http://localhost/epromaster_v1.0/api/marks/addMarks.php', jsonData[i]);

                    if (response.status === 200) {
                        setUploaded(true);
                    }
                }
                Swal.fire({
                    icon: 'success',
                    title: 'Marks Added',
                    text: 'Assessment marks has been successfully added!',
                });
            }
        } catch (error) {
        console.error('Error uploading data:', error);
        }
        finally{
            console.log('Success')
        };
    };


    // logo uploader 
    // Function to handle file change event
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    // Function to handle form submission
    // Function to handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!file) {
        Swal.fire({
            icon: 'warning',
            title: 'No file selected',
            text: 'Please select a logo file before uploading.',
        });
        return;
        }

        const formData = new FormData();
        formData.append('logo', file);

        try {
        const response = await axios.post(
            POST_IMAGE,
            formData,
            {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
            }
        );
        
        // Show success message using SweetAlert2
        if (response.data.message) {
            Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: response.data.message,
            });
        }
        } catch (error) {
        console.error('Error uploading the file:', error);
        
        // Show error message using SweetAlert2
        Swal.fire({
            icon: 'error',
            title: 'Upload Failed',
            text: 'Failed to upload the logo. Please try again.',
        });
        }
    };

    //For Pdf Result upload
    const handlePdfSubmit = async (e) => {
        e.preventDefault();

        if (!selectedFile) {
            alert('Please select a file first!');
            return;
        }

        const formData = new FormData();
        formData.append('pdfFile', selectedFile);

        try {
            const response = await axios.post(UPLOAD_PDF, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log(response);
        
            if (response.data.success) {
                Swal.fire({
                    title: 'Success!',
                    text: 'File uploaded successfully!',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
                setUploadSuccess(true);
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: response.data.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                setUploadSuccess(false);
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            Swal.fire({
                title: 'Error!',
                text: 'Error uploading file',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            setUploadSuccess(false);
        }
        
    };

    return (
        <>
        <div>
            <div className="block">
                <div className="flex mb-2">
                    <h2>Upload Students's Assessment Marks</h2>
                    <input type="file" accept=".json" onChange={handleFileUpload} />
                </div>
                <span className="mt-2"></span>
                <button className='btn btn-success' onClick={uploadData}>
                    Upload JSON
                </button>
            </div>
            <hr />
            {jsonData && (
                <div>
                <h3>Uploaded JSON Data:</h3>
                <pre>{JSON.stringify(jsonData, null, 2)}</pre>
                </div>
            )}
            {uploaded && <div>Data successfully uploaded to the server.</div>}
    </div>

    {/* Logo uploader  */}
        <div>
        <h2>Upload School Logo</h2>
        <form onSubmit={handleSubmit}>
            <div>
            <label htmlFor="logo">Select Logo:</label>
            <input 
                type="file" 
                id="logo" 
                accept="image/*" 
                onChange={handleFileChange} 
                required 
            />
            </div>
            <button button className='btn btn-success' type="submit">Upload logo</button>
        </form>
        {logoUrl && <img src={logoUrl} alt="School Logo" style={{ maxWidth: '100px' }} />}
        {message && <p>{message}</p>}
        </div>
        <hr />
        {/* PDF- Marksheet uploader   */}

        <div>
        <h2>Upload PDF Result</h2>
        <p>(Note: Filename has to be Class_RollNo e.g. N_1 - for Nursery roll no.1, KG_1 - for KG roll no. 1, For Higher Class, please follow Roman Literals i.e. I_1 for Class-1 Roll No. 1, II_1 for Class-2 Roll No.2.... etc)</p>
            <form onSubmit={handlePdfSubmit}>
                <div>
                    <label>Select PDF:</label>
                    <input type="file" accept="application/pdf" onChange={handlePdfFileChange} />
                </div>
                <button button className='btn btn-success' type="submit">Upload logo</button>
            </form>
            {uploadSuccess && <p>PDF Uploaded Successfully!</p>}
        </div>
    </>
    )
}

export default Uploader
